"use client";

import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export function DestinationShowcase({
  onDestinationClick,
}: {
  onDestinationClick: (destination: string) => void;
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const destinations = [
    {
      name: "Paris",
      image: "/chat/paris.jpg",
      description:
        "Experience the romance, art, and cuisine of the City of Light",
    },
    {
      name: "Kyoto",
      image: "/chat/kyoto.jpg",
      description:
        "Discover ancient temples, gardens, and traditional Japanese culture",
    },
    {
      name: "Santorini",
      image: "/chat/santorini.jpg",
      description:
        "Enjoy breathtaking views, blue domes, and Mediterranean charm",
    },
    {
      name: "New York City",
      image: "/chat/nyc.jpg",
      description: "Explore the vibrant metropolis that never sleeps",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === destinations.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [destinations.length]);

  return (
    <div className="relative w-full overflow-hidden rounded-xl mb-6 shadow-md">
      {/* Destinations carousel */}
      <div className="relative h-64 w-full">
        {destinations.map((destination, index) => (
          <motion.div
            key={index}
            className="absolute inset-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: index === currentIndex ? 1 : 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="relative h-full w-full">
              <Image
                src={destination.image}
                alt={destination.name}
                fill
                className="object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-white text-2xl font-bold mb-1">
                  {destination.name}
                </h3>
                <p className="text-white/90 text-sm mb-3">
                  {destination.description}
                </p>
                <button
                  onClick={() =>
                    onDestinationClick(
                      `Create a 3-day itinerary for ${destination.name}`
                    )
                  }
                  className="bg-white/20 hover:bg-white/30 hover:cursor-pointer text-white backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium transition-all"
                >
                  Get {destination.name} Itinerary
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Dots indicator */}
      <div className="absolute bottom-4 right-4 flex space-x-1">
        {destinations.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentIndex ? "bg-white scale-125" : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
